import { __extends } from "tslib";
import { WebGL2ShaderProcessor } from '../WebGL/webGL2ShaderProcessors';
/** @hidden */
var NativeShaderProcessor = /** @class */ (function (_super) {
    __extends(NativeShaderProcessor, _super);
    function NativeShaderProcessor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NativeShaderProcessor.prototype.postProcessor = function (code, defines, isFragment, processingContext, engine) {
        code = _super.prototype.postProcessor.call(this, code, defines, isFragment, processingContext, engine);
        // Depending on API, depth range is [-1..1] or [0..1]
        // This is defined by homogeneousDepth in bgfx caps
        if (!isFragment && !engine.homogeneousDepth) {
            var lastClosingCurly = code.lastIndexOf("}");
            code = code.substring(0, lastClosingCurly);
            code += "gl_Position.z = (gl_Position.z + gl_Position.w) / 2.0; }";
        }
        return code;
    };
    return NativeShaderProcessor;
}(WebGL2ShaderProcessor));
export { NativeShaderProcessor };
//# sourceMappingURL=nativeShaderProcessors.js.map